import { default as isManyDayView } from './isManyDayView';
import { CalendarLayoutBrowserConstants } from '../constants';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';
import { getSelectedViewType } from 'owa-calendar-module-store';
import { getBrowserWidthBucket } from 'owa-layout';

export function shouldShowLeftNavAsOverlay() {
    const availableWidthBucket = getBrowserWidthBucket();
    const selectedViewType = getSelectedViewType();
    if (selectedViewType === CalendarViewTypeEnum.Board) {
        return (
            availableWidthBucket <= CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_BOARD
        );
    } else {
        if (selectedViewType === CalendarViewTypeEnum.Monthly) {
            return (
                availableWidthBucket <=
                CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_MONTH
            );
        } else if (isManyDayView()) {
            return (
                availableWidthBucket <=
                CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_WEEK
            );
        }
        return (
            availableWidthBucket <= CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_DAY
        );
    }
}
